import React from "react";
// import { GatsbyImage } from "gatsby-plugin-image";
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { differenceInDays, formatDistance, format } from "date-fns";

import { getBlogUrl, toPlainText } from "../../lib/helpers";
import ButtonWithUnderline from "../Button/ButtonWithUnderline";
// import PortableText from "./portableText";

function BlogPostPreview(props) {
  const truncate = (str) => {
    return str.length > 200 ? str.substring(0, 200) + "..." : str;
  };

  return (
    <div className="group pb-12 border-b border-gray-200 mb-10">
      <AniLink
        fade
        to={getBlogUrl(props.slug.current)}
        className="no-underline"
      >
        {/* {props.featuredImage && props.featuredImage.asset && (
          <div className="overflow-hidden mb-6">
            <GatsbyImage
              image={props.featuredImage.asset.gatsbyImageData}
              // className="w-full transform scale-100 md:group-hover:scale-105 filter blur-none transition-all duration-500 ease-linear"
            />
          </div>
        )} */}
        <div className="flex flex-wrap md:flex-nowrap items-center mb-3">
          {props.categories && (
            <ul className="flex flex-wrap md:flex-nowrap">
              {props.categories.map((category, i) => (
                <li
                  className="font-display text-sm text-gray-300 font-bold tracking-wide uppercase"
                  key={i}
                >
                  {i > 0 ? <>, {category.title}</> : category.title}
                </li>
              ))}
            </ul>
          )}
          {props.categories && props.publishedAt && (
            <div className="font-display text-sm text-gray-300 font-bold tracking-wide uppercase mx-1">
              ·
            </div>
          )}
          {props.publishedAt && (
            <div className="font-display text-sm text-gray-300 font-bold tracking-wide uppercase">
              {differenceInDays(new Date(props.publishedAt), new Date()) > 3
                ? formatDistance(new Date(props.publishedAt), new Date())
                : format(new Date(props.publishedAt), "MMMM d, yyyy")}
            </div>
          )}
        </div>
        <div className="heading-three mb-3.5">{props.title}</div>
        {props._rawBody && <p>{truncate(toPlainText(props._rawBody))}</p>}
        <ButtonWithUnderline
          text={props.buttonText ? props.buttonText : "Read Article"}
        />
      </AniLink>
    </div>
  );
}

export default BlogPostPreview;
